export const loadingTimeout = 30000
